import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch, { ExtendedCacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { EPaymentMethods } from "./type.ts";

const useEquipmentKits = () => {
  const { token } = useAuth();
  const fetch = useFetch();

  const { data, isPending, isError, error } = useQuery<
    EPaymentMethods[] | null,
    Error,
    EPaymentMethods[]
  >({
    queryKey: ["payment-methods"],
    queryFn: () =>
      fetch<EPaymentMethods[]>(`${Urls.PaymentMethods}`, {
        method: "GET",
      }, true, token),
    gcTime: ExtendedCacheTime,
    staleTime: ExtendedCacheTime,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting payment methods");
    }
  }, [error?.message, isError]);

  return {
    paymentMethods: data,
    isPending,
  };
};

export default useEquipmentKits;
